import BaseModel from "../BaseModel";

export default class Customer extends BaseModel{
	static entity = 'customerSearch';
	static primaryKey = "uid"
	static fields(){
		return {
			uid: this.uid(),
			id: this.attr(null),
			data: this.attr(null),
		}
	}
	
	static route(){
		return '/customers/search/'
	}
}